// utils/navigation.ts
export const redirectToAuth = (): void => {
  window.location.href = "/";
};
